import { Box, TextFieldProps, TextField } from "@material-ui/core";
import React from "react";
import {
  ControllerRenderProps,
  Control,
  Controller,
  FormState,
  ControllerFieldState,
  useController,
} from "react-hook-form";

type RenderProps = {
  field: ControllerRenderProps<Record<string, any>, string>;
  fieldState: ControllerFieldState;
  formState: FormState<Record<string, any>>;
};

interface Props {
  name: string;
  control: Control<any>;
  textFieldProps?: Partial<TextFieldProps>;
}

export default function TextFieldWrapper(props: Props): JSX.Element {
  const { name, control, textFieldProps = {} } = props;

  const controller = useController({ control, name });
  const { field, fieldState } = controller;

  const { error } = fieldState;
  const { value, onChange } = field;

  return (
    <TextField
      variant="standard"
      fullWidth
      {...textFieldProps}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={error?.message || textFieldProps.helperText}
    />
  );

  // const render = ({ field, formState: { errors } }: RenderProps) => {
  //   const error = errors[name];

  //   return (
  //     <TextField
  //       fullWidth
  //       {...textFieldProps}
  //       value={field.value}
  //       onChange={field.onChange}
  //       error={!!error}
  //       helperText={error?.message || textFieldProps.helperText}
  //     />
  //   );
  // };

  // return <Controller render={render} name={name} control={control} />;
}
